import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { componentRegistry } from '../data/componentRegistry';
import SEO from '../components/SEO';

const ComponentsPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const componentData = componentRegistry[slug];
    const Component = componentData?.component;

    const handleBack = () => {
        navigate('/components');
    };

    if (!componentData) {
        return (
            <div className="min-h-screen bg-black pt-16 flex flex-col items-center justify-center px-4">
                <SEO
                    title="Component Not Found"
                    description="The component you're looking for doesn't exist."
                    url={`/components/${slug}`}
                />
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Component Not Found</h2>
                <p className="text-gray-400 text-base md:text-lg mb-8">
                    The component you're looking for doesn't exist.
                </p>
                <button
                    onClick={handleBack}
                    className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg font-medium hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300"
                >
                    View All Components
                </button>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 w-full h-full bg-black">
            <SEO
                title={componentData.title}
                description={componentData.description}
                url={`/components/${slug}`}
            />

            {/* Minimal Back Button - Hidden as per user request
            <button
                onClick={handleBack}
                className="fixed top-20 left-4 z-50 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 transition-all duration-200 group"
                aria-label="Back to Gallery"
            >
                <svg
                    className="w-5 h-5 text-white transition-transform duration-200 group-hover:-translate-x-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 19l-7-7 7-7"
                    />
                </svg>
            </button>
            */}

            {/* Pure Component - Full Browser Viewport with Override Styles */}
            <div
                className="absolute inset-0 [&>div]:!w-screen [&>div]:!h-screen [&>div]:!max-w-none [&>div]:!border-0 [&>div]:!rounded-none"
                style={{ width: '100vw', height: '100vh' }}
            >
                {Component && <Component />}
            </div>
        </div>
    );
};

export default ComponentsPage;
